export const taskPathResources = {
    upcoming: "upcoming",
    past: "past",
} as const;
